import DesignList from "../../components/Design/List";

const DesignListPage = () => {
  return <DesignList />;
};

export default DesignListPage;
